import { type MetricWithAttribution } from 'web-vitals';
import serverVars from 'server-vars';
import { LOCALE_US } from 'dibs-intl/exports/locales';
import { isValidMonitoringGroup, LABEL_VALUE_UNKNOWN } from 'dibs-monitoring/exports/constants';
import { sendAnalyticsData } from './perfAnalyticsHelpers';
import { type SupportedWebVital } from 'dibs-client-analytics/src/routes/cwvHandler';

const clientAnalyticsPath = 'soa/client-analytics/web-vitals/';
const trackCoreWebVitalsMutation = 'soa/graphql/persisted/analytics/v1/trackCoreWebVitalsMutation';
const validWebVitals = ['TTFB', 'LCP', 'INP', 'CLS'] as const;

const MOBILE = 'mobile' as const;
const DESKTOP = 'desktop' as const;

let useClientAnalyticsService: boolean | null = null;

export const promTrackWebVitalsMetric = (metric: MetricWithAttribution): void => {
    if (useClientAnalyticsService === null) {
        useClientAnalyticsService = serverVars.get('enablers.webVitalsUseClientAnalyticsService');
    }
    const monitoringGroupName = serverVars.get('monitoringGroupName');
    const monitoringGroup = isValidMonitoringGroup(monitoringGroupName)
        ? monitoringGroupName
        : void 0;
    const requestLocale = serverVars.get('locale') === LOCALE_US ? LOCALE_US : `non-${LOCALE_US}`;
    const deviceType = serverVars.get('settings.deviceType') === MOBILE ? MOBILE : DESKTOP;
    const queryPath = useClientAnalyticsService ? clientAnalyticsPath : trackCoreWebVitalsMutation;
    const geoContinent = serverVars.get('geo.continent') || LABEL_VALUE_UNKNOWN;

    const graphqlPayload = {
        variables: {
            input: {
                name: metric.name,
                value: metric.value,
                delta: metric.delta,
                rating: metric.rating,
                navigationType: metric.navigationType,
                monitoringGroup,
                locale: requestLocale,
                deviceType,
                geoContinent,
                ssrOnlyBot: false, // if this script is running, it means it's not SSR-only
            },
        },
    };

    const clientAnalyticsPayload = {
        metricName: metric.name,
        metricValue: metric.value,
        metricRating: metric.rating,
        monitoringGroup,
        appVersion: serverVars.get('appVersion') || `0.0.0`,
        requestLocale,
        deviceType,
        userAgent: 'not-bot', // if this script is running, it means this is not an SSR-only bot
    };

    if (monitoringGroup && validWebVitals.includes(metric.name as SupportedWebVital)) {
        sendAnalyticsData(
            `${location.protocol}//${location.host}/${queryPath}`,
            useClientAnalyticsService ? clientAnalyticsPayload : graphqlPayload
        );
    }
};
